@use '../../../styles/all' as *;

@mixin input-action-button {
  align-items: center;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-family: var(--font-light, 'Quicksand');
  font-weight: bold;
  position: absolute;
  right: 0;
}

@mixin text {
  /* Tailwind gray-900 (var emitted only by apps that use gray-900 utilities — fallback covers the rest) */
  color: var(--color-gray-900, #101828);
  font-family: var(--font-light, 'Quicksand');
  font-size: var(--size-4, 16px);
  padding: 0 16px;
}

.c-CustomInputField {
  background-color: var(--white, #fff);
  border-radius: var(--border-radius-base, 8px);
  box-sizing: border-box;
  color: var(--color-gray-900, #101828);
  display: flex;
  flex-flow: row nowrap;
  outline: none;
  position: relative;
  width: 100%;

  &--input-wrapper-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__label {
    @include field-label;
    /* Tailwind gray-900 (var emitted only by apps that use gray-900 utilities — fallback covers the rest) */
    color: var(--color-gray-900, #101828);
    display: block;
    &--required {
      &:after {
        color: var(--error);
        content: ' * ';
        font-size: 14px;
        font-weight: bold;
      }
    }
  }

  &--grouped {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &--disabled {
    background-color: var(--color-input-background-disabled);
    color: var(--color-gray-900, #101828);
    font-size: var(--size-4, 16px);
    opacity: 0.5;

    > input {
      -webkit-user-select: none; /* Safari */
      -ms-user-select: none; /* IE 10 and IE 11 */
      user-select: none;
    }
  }

  &--focused {
    // Fixed blue-700 across every brand for active states (user decision,
    // UES-12493); was the per-theme --color-input-border-focused token. The
    // !important stays — DateRangePicker's --open rule is written to match it.
    border: 1px solid var(--color-blue-700, #1447e6) !important;
    color: var(--color-gray-900, #101828);
    font-size: var(--size-4, 16px);
    font-style: normal;

    & .c-InputField__suffix--date {
      background-color: var(--color-blue-700, #1447e6);
    }
  }

  &--readOnly {
    border-color: var(--color-background-primary);
    color: var(--color-gray-900, #101828);
    font-size: var(--size-4, 16px);
    font-style: normal;
    background-color: var(--color-background-primary);
    user-select: text;
  }

  &--error {
    border: 1px solid var(--color-input-border-error);
  }

  &--error-websheet {
    border: 1px solid var(--color-error-message);
  }

  &__clear-search-input {
    @include input-action-button;

    display: flex;
    width: 32px;
    height: 32px;
    top: 50%;
    transform: translateY(-50%);
    right: -3px;
    border-radius: 100%;
  }

  &__toggle-password {
    @include input-action-button;

    align-items: center;
    color: var(--color-font-primary, #030712);
    display: flex;
    gap: 5px;
    top: -30px;

    svg {
      fill: var(--color-font-primary, #030712);
    }
  }

  &__input {
    @include text;

    &::placeholder {
      /* Tailwind gray-500 */
      color: var(--color-gray-500, #6a7282);
    }

    &:focus {
      outline: none;
    }

    background-color: inherit;
    border: none !important;
    border-radius: var(--border-radius-base, 8px);
    flex-grow: 1;
    min-width: 75px;
    user-select: text;

    &[type='number'] {
      appearance: textfield;
    }
  }

  &__input[readonly] {
    pointer-events: none;
  }

  input[type='date'] {
    appearance: textfield;
  }

  input[type='date']::-webkit-inner-spin-button,
  input[type='date']::-webkit-outer-spin-button {
    appearance: none;
  }

  &__icon {
    padding-left: rem(12px);
    position: static;
    align-items: center;
    display: flex;
  }
}
